import type { FaireProductEntity } from "../../entity_types/product";

export const p_24vjy4sgzg: FaireProductEntity = {
  token: "p_24vjy4sgzg",
  type: "product",
  name: "Kids Flower Knit Cardigan and Wide Leg Pants",
  brandToken: "b_axnmezu6gc",
  brandName: "Suhkasana",
  imageUrl:
    "https://cdn.faire.com/fastly/313579fae1fee0c80e4e763f0279b7cd571ad970afaaaf076b25b45ee15c8996.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/650b93165771ff69687f05ff4595cc695bd7dac23847805e61a1a5f9189bddc7.jpeg",
    "https://cdn.faire.com/fastly/cee1df8f319c223f9b932b1c7ef8e1232bfcbad295c22409af56afb0b3b5fafe.jpeg",
    "https://cdn.faire.com/fastly/e7403c6d49647d5b3a875ef252385db4e7e7229f36b7a6e433f780edb3a5fda5.jpeg",
    "https://cdn.faire.com/fastly/c1b07b45dd2d2c1d1ffd59c81a5491c6f585c0d9787e7cd17ec5a3bf97f20146.jpeg",
    "https://cdn.faire.com/fastly/7cf3188a0b75108d77ffd00688b63b312b07279f1019b1f8ab3e44d1f3fb7d9a.jpeg",
    "https://cdn.faire.com/fastly/2cbe33475b82b5273d03ea7daeb3d9c431ce51230db1e30f4ef4664b1629532d.jpeg",
    "https://cdn.faire.com/fastly/5dd9b1dc3f022c255b997a355c2d4c4b601219db332c8c2912ebfae680f9314d.jpeg",
    "https://cdn.faire.com/fastly/3a12a90d1d6e8aebe8c4cabdae4f292721bc8aa277de60b6960a0bad52c7ed9e.jpeg",
    "https://cdn.faire.com/fastly/e1409be2af224c894a9c48716d81cb3e6d580473f19941607bac25b03c6cece9.jpeg",
    "https://cdn.faire.com/fastly/2b8d0ff8402fd3d14c1e8584b8509c0bc0bf284e2035f0d9320a1e4a74ca1a41.jpeg",
    "https://cdn.faire.com/fastly/534f409803cced094de167d0cc16056865586e943b7988242dd23d03c0288c79.jpeg",
    "https://cdn.faire.com/fastly/7e23022d390be43c85fdb5e000fd4b566ef9b301fd0c5789b0d964d34e54f9fb.png",
  ],
  priceDollars: 32.01,
  description:
    "Trendy 2 Piece Outfit – Cute kids’ knit cardigan with matching wide leg pants, designed for a cozy yet stylish fall and winter look.\n\nPlayful Flower Embroidery – Features vibrant flower embroidery with fun smiley details, adding a cheerful and fashionable touch.\n\nCozy and Warm Design – Made with thick knit fabric, this set keeps children warm and comfortable during chilly days.\n\nEasy Mix and Match – Cardigan pairs well with tees, blouses, or dresses, while the wide leg pants can be styled with sweaters or hoodies.\n\nPerfect for Any Occasion – Ideal for school, family gatherings, casual outings, or holiday photos, giving kids a cute and trendy outfit option.\n\nBrand labels are not included by default. If needed, please add them via this link ($0.30/pc): https://www.faire.com/product/p_mbyt838sy8\n",
  tags: [],
  msrpDollars: 64.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:25.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
